export const SIGNATURE_PREFIX_REGEX = /^> .+\n/;

export const hasEmbeddedSignature = (body) =>
  typeof body === "string" && SIGNATURE_PREFIX_REGEX.test(body);

export const resolveUserSignature = (user) => {
  if (!user) return "";

  const signature = typeof user.signature === "string" ? user.signature.trim() : "";
  if (signature) return signature;

  return typeof user.name === "string" ? user.name.trim() : "";
};

export const buildSignedBody = ({
  body,
  user,
  signMessage = false,
  privateMessage = false,
  privateSuffix = ""
}) => {
  const normalizedBody = typeof body === "string" ? body : "";
  const hasVisibleContent = typeof normalizedBody === "string" && normalizedBody.trim().length > 0;

  if (!signMessage && !privateMessage) {
    return normalizedBody;
  }

  const baseSignature = resolveUserSignature(user);
  if (!baseSignature || !hasVisibleContent) {
    return normalizedBody;
  }

  const signatureLabel = privateMessage && privateSuffix
    ? `${baseSignature} - ${privateSuffix}`
    : baseSignature;

  if (hasEmbeddedSignature(normalizedBody)) {
    return normalizedBody;
  }

  return `> ${signatureLabel}\n${normalizedBody}`;
};
